angular.module('bbl.directives.sortable-col', [])
.directive('sortableCol', ['$timeout', function($timeout) {
	return {
		restrict: 'A',
		scope: {
			'sort': '=sortableCol',
			'colName': '=col'
		},
		link: function($scope, $el, atts) {
			$el.addClass('sortable-col');
			$el.bind('click', function() {
				$timeout(changeSort.bind(0, $el, $scope.sort, $scope.colName));
			});
			updateSort($el, $scope.sort);
		}
	};
}]);

var changeSort = function($el, sort, col) {
  sort.dir = !sort.dir;

  if(sort.col !== col) {
    sort.dir = false;
  }

  sort.col = col;
  sort.dirCol = (sort.dir ? '-' : '') + sort.col;
  updateSort($el, sort);
};

var updateSort = function($el, sort) {
  $el.toggleClass('desc', sort.dir);
  $el.siblings().removeClass('sortCol');
  $el.addClass('sortCol');
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/sortable-col.js
 ** module id = 165
 ** module chunks = 0
 **/